import Vue from 'vue'
import App from './App.vue'

import errorHandler from './utils/errorHandler'

import 'vuetify/dist/vuetify.min.css'

import VueResource from 'vue-resource'
Vue.use(VueResource)

import VueRouter from 'vue-router'
Vue.use(VueRouter)

Vue.directive('title', {
	inserted: (el, binding) => document.title = binding.value,
	update: (el, binding) => document.title = binding.value
})

import 'codemirror/lib/codemirror.css'
import VueCodemirror from 'vue-codemirror'
Vue.use(VueCodemirror)

import Router from './Router'
import store from './store'

import { sync } from 'vuex-router-sync'
sync(store, Router)

import Notifications from 'vue-notification'
Vue.use(Notifications)

// init

import apiConfig from '../config'
Vue.http.options.root = apiConfig.url

if (localStorage.getItem('company-name-key')) {
	Vue.http.headers.common['X-COMPANY-NAME'] = localStorage.getItem('company-name-key')
} else {
	Vue.http.headers.common['X-COMPANY-NAME'] = ''
}

Vue.http.interceptors.push((request, next) => {
	request.credentials = true;
	next(response => {
		errorHandler(response)
	})
})

store.dispatch('auth/authReady')

Vue.config.productionTip = false

new Vue({
	store,
	router: Router,
	render: h => h(App)
}).$mount('#app')
